import { render, staticRenderFns } from "./admins-create.vue?vue&type=template&id=1bb18be1&"
import script from "./admins-create.vue?vue&type=script&lang=js&"
export * from "./admins-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports